module.exports = __webpack_public_path__ + "img/hongyudong1.723bc59a.png";